import React from "react";
import { useTranslation } from "react-i18next";
import { Segmented } from "./ui";
import { useFilter, RANGES } from "../context/FilterContext";

export default function TimeFilterBar() {
  const { t } = useTranslation();
  const { range, setRange, custom, setCustom } = useFilter();
  const options = [...RANGES.map((r) => ({ value: r.value, label: t(`time.${r.value.toUpperCase()}`) })), { value: "custom", label: t("time.custom") }];
  return (
    <div className="flex flex-wrap items-center gap-3 max-w-full overflow-x-auto" data-testid="time-filter-bar">
      <Segmented options={options} value={range} onChange={setRange} testid="time-filter-segmented" />
      {range === "custom" && (
        <div className="flex items-center gap-2">
          <input data-testid="custom-start-date" type="date" className="input py-2 w-auto" value={custom.start} onChange={(e) => setCustom({ ...custom, start: e.target.value })} />
          <span className="text-slate-400">→</span>
          <input data-testid="custom-end-date" type="date" className="input py-2 w-auto" value={custom.end} onChange={(e) => setCustom({ ...custom, end: e.target.value })} />
        </div>
      )}
    </div>
  );
}
